const validate = (values) => {
    const errors = {};
  
    if (!values.libraryName) {
      errors.libraryName = 'Please enter curriculum library name';
    }
    return errors;
  };
  export default validate;
  


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/validate.js